import { html } from 'lit-html';
import { repeat } from 'lit-html/directives/repeat';
import { DropDownVariantSelectorBase,  } from "./dropdown-variant-selector-base.js";
import { IProductWithVariants, IVariant } from './variant-selector-base.js';

export class DropDownVariantSelectorV1 extends DropDownVariantSelectorBase {
    constructor(name: string, selectorContainerElement: HTMLElement, product: IProductWithVariants, variantTypeId: number, translations: Map<string, string>, showPricesInclVat: boolean, loadAdditionalInfo: boolean) {
        super(name, 1, selectorContainerElement, product, variantTypeId, translations, showPricesInclVat, loadAdditionalInfo);
    }

    protected template = () => html`
        <div class="c-variant-selector__term-definition c-variant-selector__term-definition_drop-down">
            <label for="${this.variantSelectorData.id}" class="c-variant-selector__label js-select-variant-label control-label">
                ${this.variantSelectorData.variants.length > 1 ? this.variantSelectorData.labels.select : '' } ${this.variantSelectorData.variantTypeName}
            </label>
        </div>
        <div class="c-variant-selector__term-description c-variant-selector__term-description_drop-down">
            <select id="${this.variantSelectorData.id}" class="c-variant-selector__drop-down form-control">
                <option value="0" class="c-variant-selector__drop-down-option js-default-value">${this.variantSelectorData.labels.select}...</option>
            ${repeat(this.variantSelectorData.variants, (variant:IVariant) => html`
                <option value="${variant.id}">${variant.name}</option>`
            )}
            </select>
        </div>`;

    protected getDataBeforeRender(): any {
        return {
            id: new Date().valueOf() + '_vt' + this.variantType.id,
            variantTypeName: this.variantType.name.toLowerCase(),
            variants: this.sortVariants(this.selectorContainerElement, this.variantType.variants, this.product),
            labels: { select: this.translations.get('selectVariantPrefix'), changeSelection: this.translations.get('changeSelectionVariantPrefix') }
        };
    };
}
